import { Injectable } from '@angular/core';
import { UserData } from '../../../../providers/user-data'; 
import { PageRef } from '../../../../core/core.module';
import { Observable } from 'rxjs/Observable';
import firebase from 'firebase';


@Injectable()
export class ProfileCommon {
	public realtimeDb: any;
	constructor(
		public userData: UserData,
    	public pageRef: PageRef,
    	//public settings: AppSettings,
		//public recipeData: RecipeData,

	) {
		this.realtimeDb = firebase.database();
	}

	public commonMethod(){
		console.log("Hello Profile Page");
	}

	

	public updateProfile(profile, uid){
		// Get timestamp
        var timeStamp = (<any>firebase.database).ServerValue.TIMESTAMP;
        profile.timestampModified = timeStamp;
        
        return Observable.create((observer) =>{
            var updates = {};
            // Just upload cart item
            updates['/users/' + uid + '/'] = profile;
            this.realtimeDb.ref().update(updates).then(function(){
                observer.next({result: true});
            }, function(error){
                observer.next({result: false, error: error});
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/account/pages/profile/profile.common.ts